import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { AppState } from '../../types/store';
import { getTableLayout } from '../../selectors/studio';
import { setTableLayout } from '../../actions/studio';
import { Props } from './TableLayoutSelector';

export type StateProps = Pick<Props, 'tableLayout'>;
export type DispatchProps = Pick<Props, 'onTableLayoutSelect'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  tableLayout: getTableLayout(state),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  onTableLayoutSelect: setTableLayout,
};

export default connect(mapStateToProps, mapDispatchToProps);
